import React from 'react';
import {FormGroup} from '@blueprintjs/core';

import {IItem, SimpleSelect} from '../../select';

interface ISelectSmtpProviderProps {
  emails: IItem[];
  selected: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const SelectSmtpProvider = ({
  emails,
  selected,
  onChange,
  disabled = false,
}: ISelectSmtpProviderProps) => {
  return (
    <div className="content__email__from">
      <FormGroup label="From" inline={false}>
        <SimpleSelect
          label="Select SMTP Provider"
          selected={selected}
          disabled={disabled}
          onChange={onChange}
          options={emails}
          buttonProps={{
            minimal: true,
            fill: true,
            small: true,
            outlined: true,
          }}
          popoverProps={{
            usePortal: true
          }}
        />
      </FormGroup>
    </div>
  );
};

export default SelectSmtpProvider;
